import {Routes} from '@angular/router';
import {RoleGuard} from '../../guard/auth-guard/role.guard';
import {Role} from '../../core/enums/role.enum';

export const declaracaoParticipacaoRoutes: Routes = [
  {
    path: 'declaracao-participacao',
    canActivate: [RoleGuard],
    loadComponent: () =>
      import('./declaracao-participacao.component').then(
        (m) => m.DeclaracaoParticipacaoComponent,
      ),
    data: {
      title: 'Declarações de Participação',
      breadcrumb: [
        { label: 'Declarações de Participação', url: '/declaracao-participacao' },
      ],
      roles: [Role.DECLARACAO_ATUACAO_VISUALIZAR],
    },
  },
];
